var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentFileGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 26",
    style: {
      enableBackground: "new 0 0 22 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#BAC0CB;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.1,26h17c1.1,0,2.1-0.9,2.1-2V2c0-1.1-0.9-2-2.1-2H7.3C6.6,0,5.9,0.3,5.4,0.8L0.8,5.4C0.3,5.9,0,6.6,0,7.3V24 C0,25.1,0.9,26,2.1,26z M6.5,1.9C6.7,1.7,7,1.6,7.3,1.6H19c0.3,0,0.5,0.2,0.5,0.4V24c0,0.2-0.2,0.4-0.5,0.4h-17 c-0.3,0-0.5-0.2-0.5-0.4V7.3c0-0.3,0.1-0.6,0.3-0.7L6.5,1.9z M3.3,8.1h2.8c1.1,0,2-0.9,2-2V3.3c0-0.4-0.4-0.8-0.8-0.8 S6.5,2.8,6.5,3.3v2.8c0,0.2-0.2,0.4-0.4,0.4H3.3c-0.4,0-0.8,0.4-0.8,0.8S2.8,8.1,3.3,8.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFileGrey);
export default __webpack_public_path__ + "static/media/document-file-grey.150fa64b5ac13a1e9b3af38d4cc11dd6.svg";
export { ForwardRef as ReactComponent };